import { defineMessages } from 'react-intl';

export default defineMessages({
    stream: {
        id: 'features.Viewlogy.Navigation.FuneralStream',
        defaultMessage: 'Funeral Stream',
    },
    guestList: {
        id: 'features.Viewlogy.Navigation.GuestList',
        defaultMessage: 'Guest List',
    },
    characterCloud: {
        id: 'features.Viewlogy.Navigation.CharacterCloud',
        defaultMessage: 'Character Cloud',
    },
    funeralGuide: {
        id: 'features.Viewlogy.Navigation.FuneralPlanGuide',
        defaultMessage: 'Funeral Planning',
    },
    griefSupport: {
        id: 'features.Viewlogy.Navigation.GriefSupport',
        defaultMessage: 'Grief Support',
    },
    videoMemory: {
        id: 'features.Viewlogy.Navigation.VideoMemory',
        defaultMessage: 'Video Memory',
    },
    shareEvent: {
        id: 'features.Viewlogy.Navigation.ShareEvent',
        defaultMessage: 'Share Event',
    },
    helpCenter: {
        id: 'features.Viewlogy.Navigation.HelpCenter',
        defaultMessage: 'Help Center',
    },
    carePackages: {
        id: 'features.Viewlogy.Navigation.CarePackages',
        defaultMessage: 'Care Packages',
    },
});
